import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import Modal from "../../../../../../components/common/Modal";
import PrimaryButton from "../../../../../../components/common/PrimaryButton";
import OutlinedButton from "../../../../../../components/common/OutlinedButton";
import TextInput from "../../../../../../components/forms/textInput";

interface ICreateClientPromptModalProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (description: string) => void;
}

/**
 * Collects an optional, org-facing description before creating a new API client — purely for the
 * org's own reference in its client list (OrgClientCreateRequestDTO#description), never required.
 */
const CreateClientPromptModal = ({
  open,
  handleClose,
  handleConfirm,
}: ICreateClientPromptModalProps) => {
  const { t } = useTranslation();
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!open) {
      setDescription("");
    }
  }, [open]);

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      customModalClassName={styles.modal}
      customModalContainerClassName={styles.modalContainer}
    >
      <div className={styles.container}>
        <h1 className={styles.title}>{t("lbl_create_client_prompt_title")}</h1>
        <p className={styles.subtitle}>
          {t("lbl_create_client_prompt_subtitle")}
        </p>

        <TextInput
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder={t("lbl_create_client_prompt_placeholder")}
        />

        <div className={styles.actions}>
          <PrimaryButton onClick={() => handleConfirm(description.trim())}>
            {t("lbl_create_client")}
          </PrimaryButton>
          <OutlinedButton onClick={handleClose}>
            {t("lbl_cancel")}
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default CreateClientPromptModal;
